const {SUPPORTED_IMAGE_TYPES, RAILS} = require("../config/const");

const image = (articleAssets, path) => {    
    if(RAILS.ENV == "development"){
        let tempPath =  path + articleAssets.article_id + "/" + articleAssets.file;
        return SUPPORTED_IMAGE_TYPES.includes(tempPath);
    } else{
        return SUPPORTED_IMAGE_TYPES.includes(articleAssets.content_type);
    }
}

// def image_url(version)
//     if Rails.env.production? || Rails.env.staging?
//       if version == :large
//         return helper_image_url file.relative_path, auto: :enhance, dpi: 300
//       elsif version == :tiny
//         return helper_image_url file.relative_path, w: 150, h: 150
//       else
//         return helper_image_url file.relative_path, w: 500, h: 500
//       end
//     else
//       file_url
//     end
//   end

//   def helper_image_url(source, options = {})
//     ApplicationController.helpers.ix_image_url source, options
//   end

const imageUrl = (version, fileRelativePath, fileImgPath) => {
    if(RAILS.PRODUCTION || RAILS.STAGING){
        if(version == "large"){
            return {src:fileRelativePath, options: {auto: "enhance", dpi: 300}};
        }
        else if (version == "tiny"){
            return {src:fileRelativePath, options: {w: 150, h: 150}};
        }
        else{
            return {src:fileRelativePath, options: {w: 500, h:500}};
        }
    }else{
        return  {src:fileImgPath, options: {}};
    }
}

export { image, imageUrl };